import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { PAYMENT_PREFERENCES_ANALYTICS_ACTIONS } from './payment-preferences-analytics.actions';
import { PaymentPreferencesAnalyticsMessages } from './payment-preferences-analytics.constants';
import {
  PaymentPreferencesAddBankAccount,
  PaymentPreferencesAutopaySetupStarted,
  PaymentPreferencesPageLoad,
} from './payment-preferences-analytics.transformers';

@Injectable({
  providedIn: 'root',
})
export class PaymentPreferencesAnalyticsService {
  constructor(private store: Store) {}

  trackPageLoad(countAD: number, countMD: number, customerCount: number) {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentPreferencesAnalyticsMessages.capability,
          event: PaymentPreferencesAnalyticsMessages.pageLoadedEvent,
          pageName: PaymentPreferencesAnalyticsMessages.pageName,
          counts: {
            customers: customerCount,
            autopayAccounts: countAD,
            manualDeductAccounts: countMD,
          },
        },
        transformFunc: PaymentPreferencesPageLoad,
      },
    };
    this.store.dispatch(
      PAYMENT_PREFERENCES_ANALYTICS_ACTIONS.trackPageLoad({ tracking }),
    );
  }

  trackAddNewAccounts(
    customerCount: number,
    bankAccountType: string,
    newOrExistingAccount: string,
  ) {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentPreferencesAnalyticsMessages.capability,
          event: PaymentPreferencesAnalyticsMessages.addBankAccountEvent,
          pageName: PaymentPreferencesAnalyticsMessages.pageName,
          bankAccountType,
          newOrExistingAccount,
          counts: {
            customers: customerCount,
          },
        },
        transformFunc: PaymentPreferencesAddBankAccount,
      },
    };
    this.store.dispatch(
      PAYMENT_PREFERENCES_ANALYTICS_ACTIONS.trackAddNewBankAccount({
        tracking,
      }),
    );
  }

  trackAutopaySetupStarted() {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentPreferencesAnalyticsMessages.capability,
          event: PaymentPreferencesAnalyticsMessages.buttonClickEvent,
          buttonName: PaymentPreferencesAnalyticsMessages.setupAutopayOption,
        },
        transformFunc: PaymentPreferencesAutopaySetupStarted,
      },
    };
    this.store.dispatch(
      PAYMENT_PREFERENCES_ANALYTICS_ACTIONS.trackAutopaySetupStarted({
        tracking,
      }),
    );
  }
}
